var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-content',{scopedSlots:_vm._u([{key:"sub-header",fn:function(){return [_vm._v("\n         \n    ")]},proxy:true},{key:"content",fn:function(){return [_c('span',{staticClass:"display-1"},[_vm._v("Whoops, something went wrong...")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }